import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import GroupDetailsCard from './GroupDetailsCard';
import GroupsAccounts from './GroupsAccounts';


const Groups = ({ data }) => {

  const [groupTransactionInfo, setGroupTransactionInfo] = useState([]);// State to store group details
  const [groups, setGroups] = useState([]);// State to store group details
  const [yourdue, setYourDue] = useState([]);// State to store group details
  const [customerdue, setCustomerDue] = useState([]);// State to store group details

  const [commisionType, setCommisionType] = useState([]);
  const [is_commision_taken, setCommisionProcurred] = useState([]);
  const [commision, setCommision] = useState([]);
  const [emi, setEmi] = useState([]);
  const [isGroupProgress, setGroupProgress] = useState([]);
  const [groupType, setGroupType] = useState([]);

  useEffect(() => {
    if (data && data.results) {
      console.log('Data and results are available:', data);

      // Set groupTransactionInfo when data is available
      const { groupsTabResult, yourDueResult, custDueResult, groupAccountResult, commisionType, is_commision_taken, commissionAmount, emi, groupProgress, type } = data.results;
      setGroupTransactionInfo(groupAccountResult);
      setGroups(groupsTabResult);
      setYourDue(yourDueResult);
      setCustomerDue(custDueResult);
      setCommisionType(commisionType);
      setCommisionProcurred(is_commision_taken);
      setCommision(commissionAmount);
      setEmi(emi);
      setGroupProgress(groupProgress);
      setGroupType(type);
    }
  }, [data]); // Run this effect when data prop changes
  console.log(groups);
  console.log(yourdue);
  console.log(customerdue);
  console.log(commisionType);
  console.log(is_commision_taken);
  if (!data || !data.results) {
    // Handle the case where data or data.results is null or undefined
    return <p>No data available.</p>;
  }



  const { nextAuctionDate, startTime, endTime, type, groupSubcriberResult } = data.results;

  return (<section className='section'>
    <Wrapper className='section-center' >
      <GroupsAccounts groupTransactionInfo={groupTransactionInfo} type={type} />
      <GroupDetailsCard groups={groups}
        yourdue={yourdue}
        customerdue={customerdue}
        nextAuctionDate={nextAuctionDate} // Pass columns as props
        startTime={startTime}
        endTime={endTime}
        commisionType={commisionType}
        is_commision_taken={is_commision_taken}
        commision={commision}
        emi={emi}
        isGroupProgress={isGroupProgress}
        groupType={groupType}
        groupSubcriberResult={groupSubcriberResult}
      />
    </Wrapper>
  </section>

  );
};
const Wrapper = styled.div`
  padding-top: 2rem;
  display: grid;
  gap: 3rem 2rem;
  @media (min-width: 992px) {
    grid-template-columns: 1fr 1fr;
  }
  /* align-items: start; */
`;

export default Groups;

